import { useSelector } from 'react-redux'
import { useIntl, defineMessages } from 'react-intl'
import { Select, Box, BoxProps, FormControl, FormLabel, Flex, Text } from '@homebotapp/hb-react-component-catalog'
import { selectClientHomes, selectClientId } from '../../store/selectors/client'
import { selectHomeId } from '../../store/selectors/home'
import history from '../../history'
import { routeToHome } from '../../store/selectors/routes'
import { HomeownerDigestTrackingEventLocation } from '../../constants/tracking'

export const MSG = defineMessages({
  yourAddresses: {
    id: 'Home.navigation.yourAddresses',
    defaultMessage: 'your home address'
  },
  viewingReport: {
    id: 'Home.navigation.viewingReport',
    defaultMessage: 'Viewing report for'
  }
})

export const HomeNavigation = (props: BoxProps) => {
  const intl = useIntl()

  const homes = useSelector(selectClientHomes)
  const currentHomeId = useSelector(selectHomeId)
  const clientId = useSelector(selectClientId)

  const handleOnChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    history.push(routeToHome(clientId, e.target.value))
  }

  return (
    <Box {...props}>
      <FormControl>
        <Flex align='center'>
          <FormLabel marginBottom={0}>
            <Text size='xs' fontWeight='semibold' as='span' whiteSpace='nowrap'>
              {intl.formatMessage(MSG.viewingReport)}
            </Text>
          </FormLabel>
          <Select
            justifyContent='flex-end'
            size='sm'
            name='home addresses'
            value={currentHomeId}
            onChange={handleOnChange}
            tracking={{
              guid: 'iCKaifg3uSPexfLku7Udee',
              ui_context: HomeownerDigestTrackingEventLocation.HOMEOWNER_DIGEST_ADDRESS_SELECT_COMPONENT,
              descriptor: MSG.viewingReport.defaultMessage
            }}
            mb='0'
          >
            {homes.map(home => (
              <option value={home.id} key={home.id}>
                {home.address.street}
              </option>
            ))}
          </Select>
        </Flex>
      </FormControl>
    </Box>
  )
}
